export default "__VITE_ASSET__Rq5FyGJZ__"